export default {"src":"/_next/static/media/family-owned.9a5ad414.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};